package pwgs.ui.scenes.analyticsdashboardscene

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class AAnalyticsDashboardControllerFe(props: pwgs.ui.scenes.analyticsdashboardscene.AnalyticsDashboardSceneProps, scene: MAnalyticsDashboardScene)
 : AController<pwgs.ui.scenes.analyticsdashboardscene.AnalyticsDashboardSceneProps, pwgs.ui.scenes.analyticsdashboardscene.AnalyticsDashboardSceneModel, AnalyticsDashboardSceneState>(props, scene) {

    val backend = AnalyticsDashboardControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    fun call_refreshRealtimeStats() {
        launchOnDefaultControllerScope {
            render(backend.refreshRealtimeStats())
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class AnalyticsDashboardControllerBeProxy(private val controller: AAnalyticsDashboardControllerFe) {

    suspend fun load(): pwgs.ui.scenes.analyticsdashboardscene.AnalyticsDashboardSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.analyticsdashboardscene.AnalyticsDashboardControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.analyticsdashboardscene.AnalyticsDashboardSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.analyticsdashboardscene.AnalyticsDashboardSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.analyticsdashboardscene.AnalyticsDashboardSceneModel.serializer())
        }
    }

    suspend fun refreshRealtimeStats(): pwgs.ui.scenes.analyticsdashboardscene.AnalyticsDashboardSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.analyticsdashboardscene.AnalyticsDashboardControllerBe.refreshRealtimeStats",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.analyticsdashboardscene.AnalyticsDashboardSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.analyticsdashboardscene.AnalyticsDashboardSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.analyticsdashboardscene.AnalyticsDashboardSceneModel.serializer())
        }
    }

}
